import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, VivaService } from '../_services';
import { Globals } from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-practical',
  templateUrl: './practical.component.html',
  styleUrls: ['./practical.component.css']
})
export class PracticalComponent implements OnInit {

  [x: string]: any;
  marksFormControl = new FormControl('', [
    Validators.required,
  ]);
  matcher = new MyErrorStateMatcher();

  statusMsg: string = '';
  batch_name: string = '';
  exam_name: string = '';
  exam_date;
  localData = {};
  localBatch = {};
  localStudent = {};
  loading = false;
  submitted = false;
  returnUrl: string;
  vivaData = [];
  query: string = '';
  examId: number;

  studentId: number;
  questionid: number;
  private sub: any;
  public pause = true;
  isAudio = false;
  mediaSrc: string;
  @ViewChild("videoPlayer") videoplayer: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private vivaService: VivaService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.studentId = +params['id'];
    });

    this.localData = JSON.parse(localStorage.getItem('currentUser'));
    this.localBatch = JSON.parse(localStorage.getItem('localBatch'));
    this.localExam = JSON.parse(localStorage.getItem('localExam'));
    this.getStudentData();


    this.batch_name = this.localBatch['batch_name'];
    this.exam_name = this.localBatch['exam_name'];
    this.exam_date = this.localBatch['exam_date'];
  }
  comment: string
  link: string
  bool = false

  private getStudentData() {
    this.spinner.show();
    this.submitted = true;
    this.vivaService.getpracticalMarks(this.globals.root_url, this.studentId, this.localExam['exam_id'])
      .pipe(first())
      .subscribe(
        data => {

          if (data.code == 1000) {
            this.bool = true
            this.vivaData = data.nos;
            if (data.comment) {
              this.comment = data.comment
            }
            else {
              this.comment = "No Comments"
            }
            this.link = data.link
          }
          else if (data.code == 1001) {
            this.globals.statusOpen(data.status, '/proctor-view/students');
          }

          else if (data.status == 'COM_TOKEN_ERROR') {
            this.loading = false;
            this.router.navigateByUrl('/login');
          }

          this.spinner.hide();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  }

  public redirect(){
    var abc=this.link
    window.open(abc)
  }


}
